import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { functions } from '../../firebase';
import type { AdminSensorOverviewItem } from './model';

// Validate the callable response; an unavailable inventory must not become an empty fleet.
const responseSchema = z.object({
  sensors: z.array(
    z.object({
      sensorId: z.string(),
      sensorName: z.string(),
      orgId: z.string(),
      orgName: z.string(),
      type: z.string(),
      status: z.enum(['active', 'inactive', 'unknown']),
      isActive: z.boolean(),
      deviceId: z.string().nullable(),
      ref: z.string(),
    })
  ),
});

export async function fetchFleetSensors(): Promise<AdminSensorOverviewItem[]> {
  const response = await functions.httpsCallable('settings')({
    requestType: 'GET_ADMIN_SENSOR_OVERVIEW',
  });
  const status = response.data?.httpErrorCode?.status;
  if (status && status !== 200)
    throw new Error('Enhedslisten kunne ikke hentes. Opdatér og prøv igen.');
  const parsed = responseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error('Enhedslisten kunne ikke hentes. Opdatér og prøv igen.');
  return parsed.data.sensors;
}

export function useFleetSensors() {
  return useQuery({
    queryKey: ['admin-sensor-overview'],
    queryFn: fetchFleetSensors,
    staleTime: 60_000,
  });
}
